import React from 'react';
import theme from 'styles/theme';

const normalizeColor = (color) =>
  typeof color === 'string' ? color.trim().toLowerCase() : color;

const EMPHASIS_YELLOW = theme.palette.gold.main;
const EMPHASIS_LIGHT_BLUE = theme.palette.primary.light;

const BLUE_OR_PRIMARY_COLORS = new Set([
  'primary',
  'primary.main',
  'blue',
  'blue.main',
  theme.palette.blue.main,
  theme.palette.primary.main,
  theme.palette.primary.dark,
].map(normalizeColor));

const WHITE_COLORS = new Set([
  'white',
  'white.main',
  'text.white',
  theme.palette.common.white,
  theme.palette.text.white,
  theme.palette.white.main,
].map(normalizeColor));

export const getHeadingEmphasisColor = (color) => {
  if (typeof color !== 'string') {
    return undefined;
  }

  const normalizedColor = normalizeColor(color);

  if (BLUE_OR_PRIMARY_COLORS.has(normalizedColor)) {
    return EMPHASIS_YELLOW;
  }

  if (WHITE_COLORS.has(normalizedColor)) {
    return EMPHASIS_LIGHT_BLUE;
  }

  return undefined;
};

export const renderHeadingTextWithEmphasis = (children, color) => {
  if (typeof children !== 'string' || !children.includes('**')) {
    return children;
  }

  const emphasisColor = getHeadingEmphasisColor(color);
  const segments = [];
  let cursor = 0;
  let strongIndex = 0;

  while (cursor < children.length) {
    const start = children.indexOf('**', cursor);

    if (start === -1) {
      segments.push(children.slice(cursor));
      break;
    }

    const end = children.indexOf('**', start + 2);

    if (end === -1) {
      segments.push(children.slice(cursor));
      break;
    }

    if (start > cursor) {
      segments.push(children.slice(cursor, start));
    }

    const emphasizedText = children.slice(start + 2, end);

    if (emphasizedText) {
      segments.push(
        <strong
          key={`heading-emphasis-${strongIndex}`}
          style={emphasisColor ? { color: emphasisColor } : undefined}
        >
          {emphasizedText}
        </strong>,
      );
      strongIndex += 1;
    } else {
      segments.push('****');
    }

    cursor = end + 2;
  }

  return segments;
};
